import ConstValues from 'utils/const';
const st = ConstValues.searchTypes;
/**
 * Return a search field's name corresponding to a given menu item's primaryText.
 * @param miPrimaryText {string} Menu item's primaryText
 */
export function searchFieldNameFromMenuItemPrimaryText(miPrimaryText) {
  miPrimaryText = miPrimaryText.toString();
  switch (miPrimaryText) {
    case st.miCaller:
      return 'Caller';
    case st.miContact:
      return 'Contact';
    case st.miCompany:
      return 'Company';
    case st.miCallStage:
      return 'Call Stage';
    case st.miCampaign:
      return 'Campaign';
    case st.miKeywords:
      return 'Keyword / Topic';
    case st.miPhone:
      return 'Phone';
    case st.miAnnotations:
      return 'or';
    default:
      return null;
  }
}
